module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-9ad8f5e7440aa15e1153da48f070b848.webp";